/* eslint-disable ember/no-computed-properties-in-native-classes */
import EmberObject, { computed } from '@ember/object';

import Envelope from '../process-data/envelope';

export default class ToleranceStage extends EmberObject {
  nominalCircuit = null;
  interestingCircuitArray = null;
  @computed('nominalCircuit', 'interestingCircuitArray') get magnitude() {
    var interestingCircuitsArray = this.interestingCircuitArray;
    var nominalCircuit = this.nominalCircuit;
    var nominalMagnitude = nominalCircuit.magnitude;
    var magnitudesArray = interestingCircuitsArray.map((bigHugeCircuit) => {
      return bigHugeCircuit.circuit.magnitude;
    });

    var result = Envelope.create({ nominalValuesArray: nominalMagnitude, simulatedValues: magnitudesArray });
    return result;
  }

  @computed('nominalCircuit', 'interestingCircuitArray') get phase() {
    var interestingCircuitsArray = this.interestingCircuitArray;
    var nominalCircuit = this.nominalCircuit;
    var nominalPhase = nominalCircuit.phase;
    var phaseArray = interestingCircuitsArray.map((bigHugeCircuit) => {
      return bigHugeCircuit.circuit.phase;
    });

    var result = Envelope.create({ nominalValuesArray: nominalPhase, simulatedValues: phaseArray });
    return result;
  }

  @computed('nominalCircuit', 'interestingCircuitArray') get groupDelay() {
    var interestingCircuitsArray = this.interestingCircuitArray;
    var nominalCircuit = this.nominalCircuit;
    var nominalGroupDelay = nominalCircuit.groupDelay;
    var groupDelayArrays = interestingCircuitsArray.map((bigHugeCircuit) => {
      return bigHugeCircuit.circuit.groupDelay;
    });

    var result = Envelope.create({ nominalValuesArray: nominalGroupDelay, simulatedValues: groupDelayArrays });
    return result;
  }

  @computed('nominalCircuit', 'interestingCircuitArray') get inputImpedanceMagnitude() {
    var interestingCircuitsArray = this.interestingCircuitArray;
    var nominalCircuit = this.nominalCircuit;
    var nominalInputImpedanceMagnitude = nominalCircuit.inputImpedanceMagnitude;
    var inputImpedanceMagnitudeArrays = interestingCircuitsArray.map((bigHugeCircuit) => {
      return bigHugeCircuit.circuit.inputImpedanceMagnitude;
    });

    var result = Envelope.create({
      nominalValuesArray: nominalInputImpedanceMagnitude,
      simulatedValues: inputImpedanceMagnitudeArrays,
    });
    return result;
  }

  @computed('nominalCircuit', 'interestingCircuitArray') get inputImpedancePhase() {
    var interestingCircuitsArray = this.interestingCircuitArray;
    var nominalCircuit = this.nominalCircuit;
    var nominalInputImpedancePhase = nominalCircuit.inputImpedancePhase;
    var inputImpedancePhaseArrays = interestingCircuitsArray.map((bigHugeCircuit) => {
      return bigHugeCircuit.circuit.inputImpedancePhase;
    });

    var result = Envelope.create({
      nominalValuesArray: nominalInputImpedancePhase,
      simulatedValues: inputImpedancePhaseArrays,
    });
    return result;
  }
}
